import { ReactNode, useState } from 'react';
import { Button } from '@/components/ui/button';

interface HowToUseProps {
  steps: string[];
  footer?: ReactNode;
}

function HowToUse({ steps, footer }: HowToUseProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-5">
      <Button
        variant="ghost"
        onClick={() => setOpen((s) => !s)}
        className="h-auto gap-1.5 p-0 text-sm font-normal text-foreground hover:bg-transparent"
      >
        <span className={`inline-block transition-transform duration-150 ${open ? 'rotate-90' : ''}`}>
          ›
        </span>
        ℹ️ How to use this tool
      </Button>
      {open && (
        <div className="mt-2 rounded-lg border border-border bg-muted px-4 py-3 text-sm text-muted-foreground">
          <ol className="list-decimal space-y-1 pl-4">
            {steps.map((step, i) => (
              <li key={i}>{step}</li>
            ))}
          </ol>
          {footer && <div className="mt-3 border-t border-border pt-3">{footer}</div>}
        </div>
      )}
    </div>
  );
}

export default HowToUse;
